/**
 * 一番賞分段計價，與 LotteryOrderHandler::calculateTotalPrice() 逐項對應。
 *
 * 這份數字純顯示用，實付金額仍由後端在確認抽獎的交易內重算。
 */

/** 價格可能是數字或數字字串，轉成有限數字才算得下去；轉不出來回 null。 */
function finiteNumber(value) {
    const n = typeof value === 'string' ? Number(value.trim()) : value;

    return typeof n === 'number' && Number.isFinite(n) ? n : null;
}

/**
 * 依 10 抽 / 5 抽 / 1 抽三段單價計算總價。
 *
 * 任一單價缺漏或非數字時回 null，呼叫端據此整段省略金額，
 * 而不是把 NaN 渲染進畫面。
 *
 * @param {number} qty 抽數
 * @param {number|string} price1 單抽的每抽價
 * @param {number|string} price5 5 抽的每抽價
 * @param {number|string} price10 10 抽的每抽價
 * @returns {number|null} 總價；單價不完整時 null
 */
export function drawTotalPrice(qty, price1, price5, price10) {
    const p1 = finiteNumber(price1);
    const p5 = finiteNumber(price5);
    const p10 = finiteNumber(price10);

    if (p1 === null || p5 === null || p10 === null) {
        return null;
    }

    const n = finiteNumber(qty);
    if (n === null || n <= 0) {
        return 0;
    }

    const count = Math.floor(n);
    const tens = Math.floor(count / 10);
    const fives = Math.floor((count % 10) / 5);
    const ones = count % 5;

    return tens * 10 * p10 + fives * 5 * p5 + ones * p1;
}
